import React, { Component } from "react";

class About extends Component{
    render(){
        let title = 'Sobre nosotros',
        description = 'Somos un grupo de apasionados por el desarrollo de proyectos de software que con 13-15 años empezamos a realizar redes de servidores de videojuegos, entre ellas una de las más famosas a nivel de habla hispana en el videojuego Minecraft con más de medio millón de usuarios. A partir de ahí hemos realizado numerosos proyectos, tanto fracasos como éxitos. Entre ellos se encuentran aplicaciones móviles como Go2Market, tiendas de venta de videojuegos, servidores y desarrollo de servidores personalizados de videojuegos a influencers (Como Ibai, IlloJuan, etc). A dia de hoy, hemos decidido no solo hacer proyectos individuales sino abrirnos al público para ofrecerles nuestros servicios. Entre nuestros principales clientes se encuentran el Gobierno de Tamaulipas (México) y el Congreso de Fenamix, una red española de puestos de loterias.';
        return(
            <React.Fragment>
                <div className="about-wrapper">
                    <div className="container">
                        <div className="row row--35 align-items-center">

                            <div className="col-lg-5 col-md-12">
                                <div className="thumbnail">
                                    <img className="w-100" src="/assets/images/about/about-1.jpg" alt="About Images"/>
                                </div>
                            </div>

                            <div className="col-lg-7 col-md-12">
                                <div className="about-inner inner">
                                    <div className="section-title">
                                        <h2 className="title">{title}</h2>
                                        <p className="description">{description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default About;